import { OtherService, ResponseDictionaryByType } from '@ads/front-core/api'
import { IProductDefinition } from '@ads/front-core/products/IProductDefinition'
import { EyeDotted } from '@ads/front-core/Icons/wizard'
import { lng } from '@ads/front-core/locales'
import { ProductFor, WizardSubCategoryEnum } from '@ads/front-core/interfaces'
import limits from '@ads/front-core/constants/limits'
import { campaignMaxDateByDays } from './utils'

export const STICKY_AD: IProductDefinition = {
  productTypeId: 'STICKY_AD',
  productAvailableFor: [ProductFor.NONPUBLISHER],
  createUrl: '/campaign/create/sticky-ad/',
  title: 'campaign:stickyAds.title',
  budget: {
    model: 'VCPM',
    type: 'TOTAL',
    variant: 'ANY',
    validation: {
      rate: {
        min: 18,
        max: limits.MAXIMUM_RATE_CPM,
      },
    },
  },
  campaignMinimumRates: {
    fields: ['DEFAULT'],
    inputType: 'currency',
  },
  campaignMaxDate: campaignMaxDateByDays(90),
  capping: true,
  allowedCreationTypes: ['BANNER'],
  campaignHowToWorks: 'campaign:stickyAds.howDisplayWorks',
  creationsDescription: {
    description: 'campaign:marketplace.stickyCreationDescription',
    params: {
      formats: 'jpeg/png',
      dimension: '320x50',
      maxFileSize: '30kB',
    },
  },
  targeting: {
    countries: true,
    demography: true,
    locations: true,
    segmentsTab: ['segments', 'retargetingSegments'],
    allowedDomains: async () => {
      const res = await OtherService.getDictionaryByType({
        type: 'sticky-campaign-domain',
      })
      return (res as ResponseDictionaryByType)?.map(item => item.value)
    },
  },
  wizard: {
    subCategory: WizardSubCategoryEnum.STICKY_AD,
    productDescription: {
      title: lng('wizard:numberOfViews'),
      description: lng('wizard:stickyDescription'),
      Icon: EyeDotted,
    },
    parameters: [
      {
        label: lng('campaign:format'),
        value: lng('campaign:banner'),
      },
      {
        label: lng('campaign:billingModel'),
        value: lng('wizard:budgetModel.vcpm'),
      },
      {
        label: lng('wizard:destination'),
        value: lng('wizard:buildingAwarenessReach'),
      },
    ],
  },
}
